(() => {
  function debounce(fn, delay3) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay3);
    };
  }
  window._debounce = debounce;

  // 公共类可继承open属性
  const GlobalHTMLElement = class extends HTMLElement {
    static get observedAttributes() {
      return ["open"];
    }
    constructor() {
      super();
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(value) {
      if (value) {
        (async () => {
          this.setAttribute("open", "");
        })();
      } else {
        this.removeAttribute("open");
      }
    }

    listenerKeydown() {
      document.addEventListener("keydown", (e) => {
        if (this.open == true && e.code == "Escape") {
          this.open = false;
        }
      });
    }
  };

  // swiper-component 自定义轮播组件
  customElements.define(
    "swiper-component",
    class SwiperComponent extends GlobalHTMLElement {
      custom_pagination = {
        total: 0,
        current: 0,
      };
      swiper_options = {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: false,
        autoplay: false,
        watchOverflow: true,
      };
      constructor() {
        super();
        // 执行一次
        this.lock = true;
        // 自定义切换按钮
        this.custom_prev_btn = this.querySelector(".swiper-pagination-prev");
        this.custom_next_btn = this.querySelector(".swiper-pagination-next");
        this.custom_swiper_tabs = this.querySelectorAll(".swiper-tab-item");
      }
      // disconnectedCallback() {
      //   this.swiper.destroy(true, true);
      // }
      attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
          case "open":
            if (this.hasAttribute("open") && this.lock) {
              this.lock = false;
              this.startSwiper();
            }
        }
      }
      startSwiper() {
        this.initPagination();
        this.initSwiper();
        // 自定义切换按钮
        this.initCuPaginationButton();
      }

      initSwiper() {
        Object.keys(this.dataset).forEach((key) => {
          this.swiper_options[key] = JSON.parse(this.dataset[key]);
        });
        this.swiper = new Swiper(this.querySelector(".swiper"), {
          ...this.swiper_options,
        });
        this.swiper["custom_pagination"] = this.custom_pagination;
        this.swiper.on("slideChange", (item) => {
          this.custom_pagination["current"] = item.realIndex + 1;
          this.swiper["custom_pagination"] = this.custom_pagination;
          this.updateCuPaginationButton();
          this.selectTabsItem(item.realIndex);
        });
      }
      slideTo(index) {
        this.swiper.slideTo(index);
      }
      getSwiper() {
        return this.swiper
      }

      initPagination() {
        if (
          this.querySelector(".swiper-button-next") &&
          this.querySelector(".swiper-button-prev")
        ) {
          this.swiper_options.navigation = {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          };
        }
        if (this.querySelector(".swiper-pagination")) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          };
        }
        if (
          this.querySelector(
            ".swiper-pagination.swiper-pagination-dynamicBullets"
          )
        ) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            dynamicBullets: true,
          };
        }
        if (this.querySelector(".swiper-pagination-custom")) {
          const _this = this;
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination-custom"),
            clickable: true,
            type: "custom",
            renderCustom: function (swiper, current, total) {
              _this.custom_pagination = {
                current,
                total,
              };
              return null;
            },
          };
        }
      }
      initCuPaginationButton() {
        if (this.custom_next_btn && this.custom_prev_btn) {
          this.updateCuPaginationButton();
          this.custom_prev_btn.onclick = () => {
            this.swiper.slidePrev();
            this.updateCuPaginationButton();
          };
          this.custom_next_btn.onclick = () => {
            this.swiper.slideNext();
            this.updateCuPaginationButton();
          };
        }
        if (this.custom_swiper_tabs.length) {
          this.selectTabsItem(0);
          this.custom_swiper_tabs.forEach((item, index) => {
            item.onclick = () => {
              this.selectTabsItem(index);
            };
          });
        }
      }

      selectTabsItem(index) {
        if (this.custom_swiper_tabs.length) {
          $(this.custom_swiper_tabs)
            .not(this.custom_swiper_tabs[index])
            .removeClass("active");
          this.custom_swiper_tabs[index].classList.add("active");
          this.swiper.slideTo(index);
        }
      }
      updateCuPaginationButton() {
        if (!this.custom_next_btn && !this.custom_prev_btn) return;
        this.custom_prev_btn.disabled = this.swiper.activeIndex == 0;
        this.custom_next_btn.disabled = this.swiper.isEnd;
      }
    }
  );

  // 唤醒弹窗按钮 需传入对应弹窗id
  class GlobalModalButton extends HTMLElement {
    constructor() {
      super();
      // this.initContent()
      this.init()
    }
    init() {
      if (!this.dataset.id) return;
      const modalContainer = document.getElementById(this.dataset.id);
      this.addEventListener("click", () => {
        modalContainer.toggleAttribute("open", !modalContainer.open);
        this.setAttribute(
          "aria-expanded",
          this.getAttribute("aria-expanded") == "false" ? true : false
        );
      });
      modalContainer.addEventListener("click", (element) => {
        if (element.target == modalContainer && modalContainer.open == true) {
          modalContainer.open = false;
        }
      });
    }
  }
  customElements.define("global-modal-button", GlobalModalButton);

  // 加购按钮
  customElements.define(
    "add-cart-button",
    class AddCartButton extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.addEventListener("click", () => {
          this.addToCart(this.dataset.variantId);
        });
      }
      addToCart(variantId) {
        const _this = this;
        let formData = {
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        };
        this.classList.add("loading");
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((res) => {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: res,
                  openMiniCart: true,
                },
              })
            );
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            _this.classList.remove("loading");
          });
      }
    }
  );

  customElements.define(
    "image-lazy-load",
    class ImageLazyLoad extends HTMLElement {
      constructor() {
        super();
        this.image = this.querySelector(".img--lazyload");
        this.initImageLazyLoad();
      }

      initImageLazyLoad() {
        if ("IntersectionObserver" in window) {
          const lazyImageObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                let lazyImage = entry.target;
                lazyImage.src = lazyImage.dataset.src;
                lazyImage.classList.add("lazyloaded");
                observer.unobserve(entry.target);
              }
            });
          });
          lazyImageObserver.observe(this.image);
        } else {
          let active = false;
          const _this = this;
          let lazyLoad = () => {
            if (active === false) {
              active = true;
              setTimeout(() => {
                const lazyImage = _this.image;
                if (
                  lazyImage.getBoundingClientRect().top <= window.innerHeight &&
                  lazyImage.getBoundingClientRect().bottom >= 0 &&
                  getComputedStyle(lazyImage).display !== "none"
                ) {
                  lazyImage.src = lazyImage.dataset.src;
                  // lazyImage.classList.remove("lazy");
                  lazyImage.classList.add("lazyloaded");
                }
                active = false;
              }, 200);
            }
          };
          document.addEventListener("scroll", lazyLoad);
          window.addEventListener("resize", lazyLoad);
          window.addEventListener("orientationchange", lazyLoad);
        }
      }
    }
  );

  class NavigationSticky extends HTMLElement {
    constructor() {
      super();
      this.stickyContainer = document.getElementById(
        `${this.dataset.stickyId}`
      );
      if (!this.stickyContainer) return;
      this.headerHeight =
        document
          .querySelector(".shopify-section--header")
          ?.getBoundingClientRect().height ?? 0;
      this.announcementBarHeight =
        document
          .querySelector(".shopify-section--announcement-bar")
          ?.getBoundingClientRect().height ?? 0;
      this.listenerScroll();
      this.listenerItemHandle()
    }

    listenerItemHandle() {
      const links = Array.from(this.querySelectorAll(".product-navigation-link"))
      links.forEach((item) => {
        item.onclick = () => {
          item.classList.add("active")
          links.filter(t => t != item).forEach(t => t.classList.remove('active'))
        }
      })
    }
    listenerScroll() {
      window.addEventListener("scroll", () => {
        if (this.getScrollTop() > this.getBoundingClientRect().top) {
          this.updateElementTopValue();
        }
      });
    }
    updateElementTopValue() {
      if (this.isScrollDown()) {
        this.stickyContainer.style.top = `-${this.headerHeight}px`;
      } else {
        this.stickyContainer.style.top = `${this.headerHeight + this.announcementBarHeight
          }px`;
      }
    }
    isScrollDown() {
      const scrollY = this.getScrollTop();
      let delta = scrollY - this.curScrollY;
      this.curScrollY = scrollY;
      return delta > 0;
    }
    getScrollTop() {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY ||
        0
      );
    }
  }
  customElements.define("navigation-sticky", NavigationSticky);

  customElements.define(
    "scroll-number",
    class ScrollNumber extends HTMLElement {
      constructor() {
        super();
        this.init()
      }
      init() {
        this.querySelectorAll(".count--number").forEach((element) => {
          const target = parseInt(element.dataset.target, 10);
          const duration = parseInt(element.dataset.duration, 10);
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.animateNumber(entry.target, target, duration);
                  observer.unobserve(entry.target); // 触发后取消观察
                }
              });
            },
            { threshold: 0.5 }
          ); // 当元素 50% 进入视口时触发

          observer.observe(element);
        });
      }
      animateNumber(element, target, duration) {
        let startTimestamp = null;
        const initialNumber = 0;

        // 缓动函数集合
        const easingFunctions = {
          // 默认线性（无缓动）
          linear: (progress) => progress,

          // 加速后减速（标准缓动）
          easeInOutQuad: (progress) => {
            return progress < 0.5
              ? 2 * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 2) / 2;
          },

          // 结尾减速（常用效果）
          easeOutQuad: (progress) => {
            return 1 - (1 - progress) * (1 - progress);
          },

          // 弹性效果
          easeOutElastic: (progress) => {
            const c4 = (2 * Math.PI) / 3;
            return progress === 0
              ? 0
              : progress === 1
                ? 1
                : Math.pow(2, -10 * progress) *
                Math.sin((progress * 10 - 0.75) * c4) +
                1;
          },
        };

        const updateNumber = (timestamp) => {
          if (!startTimestamp) startTimestamp = timestamp;

          const elapsed = timestamp - startTimestamp;
          const rawProgress = Math.min(elapsed / duration, 1);

          // 使用缓动函数（这里选择 easeOutQuad）
          const easedProgress = easingFunctions.easeInOutQuad(rawProgress);

          const current = Math.floor(easedProgress * target);

          element.textContent = current;

          if (rawProgress < 1) {
            requestAnimationFrame(updateNumber);
          } else {
            element.textContent = target;
          }
        };
        requestAnimationFrame(updateNumber);
      }
    }
  );

})();
